import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_411_def implements Validator {

	public static id = 'CTRL_411_def';
	private message = 'error.ctr_411';


	public LOG: LogService = new LogService(CTRL_411_def);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {


		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_411_def.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const dateRecepOffreWithStepId = map.get(ctrl.value.rgCtrls.dateRecepOffre);
				const dateReceptCandidatureWithStepId = map.get(ctrl.value.rgCtrls.dateReceptCandidature);
				const dateRecepOffreCtrl = form.controls[dateRecepOffreWithStepId];
				const dateReceptCandidatureCtrl = form.controls[dateReceptCandidatureWithStepId];

				if (dateReceptCandidatureCtrl.value !== 'yyyy-MM-dd' && dateReceptCandidatureCtrl.value !=="" && dateRecepOffreCtrl.value !== 'yyyy-MM-dd' && dateRecepOffreCtrl.value !=="" && new Date(dateReceptCandidatureCtrl.value).getTime() >= new Date(dateRecepOffreCtrl.value).getTime()) {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
			}
		}
	}
}
